import { Box, keyframes } from "@mui/material";
import AppLogo from "../../../assets/icons/iconShanenLi.svg";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
`;

export const LoaderComponent = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        right: 0,
        zIndex: 10,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
        backgroundColor: "rgba(245, 245, 245, 0.4)",
      }}
    >
      <Box
        component="img"
        src={AppLogo}
        alt="Loading..."
        sx={{
          width: "80px",
          height: "80px",
          animation: `${rotate} 2s linear infinite`,
          filter: "drop-shadow(0px 0px 4px gray)",
        }}
      />
    </Box>
  );
};